<template>
  <div class="max-w-[60ch] pb-[32px]" ref="greetingsTemplateRef" tabindex="-1">
    <strong class="font-neo-screen-head font-bold text-2xl">{{
      successMessage
    }}</strong>

    <GreetingsFromUs class="mt-s" />

    <UtilityButton
      class="mt-s"
      v-if="!isWebview()"
      :button="{
        type: 'ghost',
        link: getPagePath['home']![locale]!,
        text: $t('dbc-button-return-to-home'),
      }"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  successMessage: string
}>()

const { locale } = useI18n()

const greetingsTemplateRef = ref<HTMLElement | null>(null)

onMounted(() => {
  greetingsTemplateRef.value?.scrollIntoView()
  greetingsTemplateRef.value?.focus()
})
</script>
